import React from "react";
import CustomModalContainer from "../../../components/modals/CustomModalContainer";
import moment from "moment";

interface ViewKycModalProps {
  open: boolean;
  onClose: () => void;
  data: any;
}

const ViewKycModal: React.FC<ViewKycModalProps> = ({ open, onClose, data }) => {
  if (!data) return null;

  const { user } = data;

  const documentLinks = [
    { label: "NIN Document", url: data?.ninFileUrl },
    { label: "BVN Document", url: data?.bvnFileUrl },
    { label: "CAC Document", url: data?.cacFileUrl },
    { label: "Utility Bill", url: data?.utilityFileUrl },
  ];

  return (
    <CustomModalContainer open={open} onClose={onClose} title="KYC Details">
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <strong>Full Name:</strong> {user?.firstName} {user?.lastName}
        </div>
        <div>
          <strong>Email:</strong> {user?.email ?? "N/A"}
        </div>
        <div>
          <strong>Phone:</strong> {user?.phoneNumber ?? "N/A"}
        </div>
        <div>
          <strong>City:</strong> {data?.city ?? "N/A"}
        </div>
        <div>
          <strong>State:</strong> {data?.state ?? "N/A"}
        </div>
        <div>
          <strong>Address:</strong> {data?.address ?? "N/A"}
        </div>
        <div>
          <strong>NIN:</strong> {data?.nin ?? "N/A"}
        </div>
        <div>
          <strong>BVN:</strong> {data?.bvn ?? "N/A"}
        </div>
        <div>
          <strong>CAC:</strong> {data?.cac ?? "N/A"}
        </div>
        <div>
          <strong>Status:</strong> {user?.kycStatus ?? "N/A"}
        </div>
        <div>
          <strong>Submitted At:</strong>{" "}
          {moment(data?.createdAt).format("Do MMM YYYY")}
        </div>
        <div>
          <strong>Beginner:</strong>{" "}
          <span
            className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${
              data?.beginner
                ? "bg-green-100 text-green-700"
                : "bg-gray-200 text-gray-600"
            }`}
          >
            {data?.beginner ? "Yes" : "No"}
          </span>
        </div>
        <div>
          <strong>Address Verified:</strong>{" "}
          <span
            className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${
              data?.addressVerified
                ? "bg-green-100 text-green-700"
                : "bg-gray-200 text-gray-600"
            }`}
          >
            {data?.addressVerified ? "Yes" : "No"}
          </span>
        </div>
        <div>
          <strong>BVN Verified:</strong>{" "}
          <span
            className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${
              data?.bvnVerified
                ? "bg-green-100 text-green-700"
                : "bg-gray-200 text-gray-600"
            }`}
          >
            {data?.bvnVerified ? "Yes" : "No"}
          </span>
        </div>
        <div>
          <strong>NIN Verified:</strong>{" "}
          <span
            className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${
              data?.ninVerified
                ? "bg-green-100 text-green-700"
                : "bg-gray-200 text-gray-600"
            }`}
          >
            {data?.ninVerified ? "Yes" : "No"}
          </span>
        </div>
        <div>
          <strong>CAC Verified:</strong>{" "}
          <span
            className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${
              data?.cacVerified
                ? "bg-green-100 text-green-700"
                : "bg-gray-200 text-gray-600"
            }`}
          >
            {data?.cacVerified ? "Yes" : "No"}
          </span>
        </div>
      </div>

      {/* Document Links */}
      <div className="mt-6 space-y-2">
        {documentLinks.map(
          (doc) =>
            doc.url && (
              <a
                key={doc.label}
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                download
                className="block text-blue-600 underline"
              >
                View {doc.label}
              </a>
            )
        )}
      </div>
    </CustomModalContainer>
  );
  
};

export default ViewKycModal;
